import { useState, useRef, useEffect } from 'react';
import { LinkButton } from '@/ui';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { getDeadTime, getTimeRemaining } from '@/utils/helpers';
import { usePopups } from '@/hooks';

const CodeCountdown = ({
  sendCode,
  triggerSendCode,
  isInitialCall = false,
  minutes = null,
  seconds = 59
}) => {
  const Ref = useRef(null);
  const { t } = useTranslation();
  const { showInfoToast } = usePopups();
  const [timer, setTimer] = useState('00:00');
  const [showText, setShowText] = useState(false);
  const [isCodeSent, setIsCodeSent] = useState(false);

  useEffect(() => {
    clearTimer(getDeadTime(minutes, seconds));
    setShowText(true);
    setIsCodeSent(true);
    if (isInitialCall) {
      handleSendCode();
    }
  }, []);

  useEffect(() => {
    if (triggerSendCode) handleSendCode();
  }, [triggerSendCode]);

  const handleSendCode = () => {
    sendCode()
      .then(() => {
        clearTimer(getDeadTime(minutes, seconds));
        setIsCodeSent(true);
      })
      .catch((e) => {
        console.error(e);
        showInfoToast(e, true);
      });
  };

  const startTimer = (e) => {
    let { total, minutes, seconds } = getTimeRemaining(e);
    if (total >= 0) {
      setTimer(
        (minutes > 9 ? minutes : '0' + minutes) + ':' + (seconds > 9 ? seconds : '0' + seconds)
      );
    } else {
      setIsCodeSent(false);
    }
  };

  const clearTimer = (e) => {
    setTimer(`${minutes ?? '00'}:${seconds ?? '00'}`);
    if (Ref.current) clearInterval(Ref.current);
    const id = setInterval(() => {
      startTimer(e);
    }, 1000);
    Ref.current = id;
  };

  return (
    <CodeSend>
      {showText && (
        <>
          {isCodeSent ? (
            <>
              <span>{t('You can resend code in')} </span>
              <span>{timer}</span>
            </>
          ) : (
            <>
              <span>{t('Didn’t receive the code?')} </span>
              <LinkButton onClick={() => handleSendCode()}>{t('Try again')}</LinkButton>
            </>
          )}
        </>
      )}
    </CodeSend>
  );
};

const CodeSend = styled.div`
  height: 24px;
  font-size: 16px;
`;

export default CodeCountdown;
